export default {
    domain: 'Domain',
    domains: 'Domains',
    alias: 'Alias',
    forward_to: 'Forward To',
    source_url: 'Source URL',
    destination_url: 'Destination URL',
    dns_setting: 'DNS Setting',
    redirect_email: 'Redirect Email',
    redirect_domain: 'Redirect Domain',
    domain_contact: 'Domain Contact',
    extend_domain: 'Extend Domain',
    reactivate_domain: 'Reactivate Domain',
    domain_status_info: {
        active: 'Domain is currently active',
        expired: 'Domain has expired',
        alert: 'Domain has less than 30 days till expiration',
        grace: 'Domain has expired within 30 days. It may be possible for you to purchase the domain again.',
        transferred: 'Domain has been transferred to a new owner',
    },
    reg_date: 'Reg Date',
    next_due: 'Exp Date',
    status: 'Status',
    created_date: 'Created Date',
    dns_management: 'DNS Management',
    advanced_dns_setting: 'Advanced DNS Setting',
    what_is_dns_management: 'What is DNS Management?',
    learn_more: 'Learn More',
    type: 'Type',
    host: 'Host',
    value: 'Value',
    ttl: 'TTL',
    priority: 'Priority',
    add_new_record: 'Add New Record',
    set_up_two_click: 'Set up your app in two clicks',
    choose_dns_template: 'Choose DNS Template',
    dns_template_content: {
        1: 'Your DNS records will be set up to point your domain to the application you select.',
        2: 'Learn more about this feature in our <a href="" class="text-cinnabar text-underline">Knowledge base.</a>',
    },
    txt_record: 'TXT Record',
    mx_record: 'MX Record',
    mxe_record: 'MXE Record',
    mail_setting: {
        1: 'Need to add or update?',
        2: 'Private Email automatically configured for google.com',
    },
    ip_address: 'IP Address',
    personal_dns_servers: 'Personal DNS Servers',
    learn_feature: 'Learn to use this feature',
    register_name_server: 'Register Nameserver',
    nameserver: 'Nameserver',
    find_nameserver: 'Find Nameservers',
    standard_server: 'Standard Nameservers',
    auto_renew: 'Auto Renew',
    expired_date: 'Expired Date',
    with_held_for_privacy: 'What is WithheldforPrivacy.',
    protection: 'Protection',
    basic_dns: 'Basic DNS',
    custom_dns: 'Custom DNS',
    onebyte_dns: '1Byte DNS',
    onebyte_wp_dns: '1Byte WP Hosting DNS',
    add_nameserver: 'Add nameserver',
    nameserver_hint:
        'Nameservers help connect URLs with the IP address of web servers. Nameservers are an important part of the Domain Name System (DNS), which many people call the “phone book of the Internet”.',
    redirect_email_tips:
        'Our free Email Forwarding feature allows you to create personalized email addresses for a domain and forward emails to other email addresses of your choice.',
    redirect_email_tip_detail:
        'Email Redirect is a free service that allows you to receive emails at your personal you@yourdomain.com email address by redirecting them to another email account. If you are using Private Email, use its interface to set up a redirect.',
    what_does_it_do: 'What does it do?',
    redirect_email_contact_hint:
        'Each domain registered must include contact details. These are stored in a public WHOIS database so that the domain owner can be contacted, as needed. We call them “Domain Contacts” (aka. Whois Contacts). Customers have the ability to edit them.',
    learn_more_personal: 'Learn more about personal domain contacts',
    modal_edit_contact_title: 'Edit contact',
    setting: 'Setting',
    mail_settings: 'MAIL SETTINGS',
    personal_dns_server: 'PERSONAL DNS SERVER',
    host_record: 'HOST RECORDS',
    host_record_text:
        'You can manage host records in your cPanel account, or transfer DNS back to 1Byte Basic DNS to manage the records here.',
    mail_setting_text:
        'You can manage mail settings in your cPanel account, or transfer DNS back to 1Byte Basic DNS to manage the records here',
    domain_transfer: 'Domain Transfer',
    transfer_in: 'Transfer In',
    domain_transfer_search: {
        title: 'Start Domain Transfer',
        subtitle:
            'Input your domain below and let us guide you through the process.',
        placeholder: 'Enter your domain here',
    },
    domain_transfer_error: {
        not_available: {
            title: 'Your domain {domain} is not available for transfer',
            description:
                'Please try searching for your domain again in the search box above or contact our support team for help.',
        },
        not_yet_purchased: {
            title: 'Your domain {domain} has not been purchased yet',
            description:
                'Please try searching for your domain again in the search box above or contact our support team for help.',
        },
        already_exists: {
            title: 'Your domain {domain} already exists in our system',
            description:
                'Please try searching for your domain again in the search box above or contact our support team for help.',
        },
    },
    transfer_checklist: 'Transfer checklist',
    transfer_checklist_hint:
        'To ensure a successful transfer, please follow our transfer checklist below.',
    transfer_checklist_alert:
        'Great news! Your domain {domain} is eligible for transfer.',
    year_transfer: 'year transfer | years transfer',
    current_registrar: 'Current Registrar',
    authorization_code: 'Authorization Code',
    authorization_code_placeholder: 'Enter authorization code here',
    authorization_code_hint:
        'Domain transfer authorization codes (also known as Auth Code/EPP Codes) provide an additional layer of security for your domain. You’ll need to obtain this code from your current registrar.',
    domain_transfer_guide: {
        title: '1Byte’s Simplified Domain Transfer Process',
        subtitle:
            "Looking to smoothly transfer your domain? With 1Byte, it's a breeze.",
        domain_type_requirements: 'domain type requirements',
        steps: {
            1: {
                title: '1. Verify Your Domain',
                description:
                    'Input your domain into our search bar and ensure it meets our transfer criteria.',
            },
            2: {
                title: '2. Prepare it for transfer',
                description:
                    'Check your {domainTypeRequirements} and have your authorization code ready.',
            },
            3: {
                title: '3. Transfer Your Domain',
                description:
                    'Proceed to checkout with your domain, make the payment, and expect completion within 30 minutes to 6 days.',
            },
        },
    },
    domain_transfer_faq: {
        title: 'FAQs on Domain Transfer',
        subtitle:
            'Your queries answered. Discover more about domain transfer with 1Byte.',
    },
};
